<template>
  <div class='report-item report-item--statgroup brand-background-color' :style='{backgroundColor: computedBackgroundColor}'>
    <div class="text" :style='{color: theme.color}'>
      <ContentEditable :style='{color: titleColor}' :html='true' class='brand-text-color content-title' tag='h1' :editable='editable' v-model='content.title' :font-scale='titleFontSize' :translated='$t(content.title, "title", this.tag)'></ContentEditable>
      <ContentEditable :style='{color: textColor}' :font-scale='textFontSize' class='content-text' :html='true' tag='div' :editable='editable' v-model='content.text' :translated='$t(content.text, "text", this.tag)'></ContentEditable>
      <div class="stats" v-if='config.stats.length > 0' :style='{backgroundColor: this.theme.statBoxColor}'>
        <Stat ref='statItems' @change='refreshStat(i, $event)' :translated='$t(stat.text, `stats.${i}.text`, tag)' @edit='onEditStat($event)' :config='stat' :circle='false' :theme='theme' @delete='deleteStat' :editable='editable' :id='i' :data='report.stats' :key='stat.key' v-for='stat,i in config.stats'></Stat>
      </div>
      <div class='actions' v-if='editable'>
        <h2 class='editHeading' @click.prevent='createStat'>Add a statistic <ion-icon name="add-circle-outline"></ion-icon></h2>
      </div>
    </div>
    <div v-if='editable'>
      <UIActions @delete='onDelete' @add='onAdd' @edit='onEdit'></UIActions>
    </div>
  </div>
</template>
<script>
import UIActions from './UIActions.vue'
import Vue from 'vue'
import ContentEditable from '../../ContentEditable.vue'
import _ from 'lodash';
import Stat from './Stat'
import StatEditor from '../../report-editor/components/StatEditor'
import TranslationMixin from '../lib/TranslationMixin'
export default {
  props: {
    config: {default: ()=>{{}}, type: Object},
    editable: {default: true, type: Boolean},
    report: {default: ()=>{{}}, type: Object},
    response: {default: ()=>{{}}, type: Object}
  },
  mixins: [TranslationMixin],
  data () {
    return {
      content: {},
      ready: false,
      newStat: null
    }
  },
  components: {
    UIActions,
    ContentEditable,
    StatEditor,
    Stat
  },
  inject: ['globalTheme'],
  methods: {
    onEdit () {
      this.$emit('edit', {target: this, fields: null, editorClass: 'StatGroupEditPanel'})
    },
    onEditStat (event) {
      this.$emit('edit', event)
    },
    onDelete () {
      this.$emit('delete')
    },
    onAdd () {
      this.$emit('add')
    },
    generateKey () {
      let randKey = [...Array(10)].map( (i) => {
        return Math.floor((Math.random()*36)).toString(36)
      }).join('')
      return randKey
    },
    createStat () {
      let payload = {
        questionText: '',
        format: 'percentage',
        text: '',
        showValue: true,
        valueText: '',
        figureFontSize: null,
        captionFontSize: null,
        figureColor: null,
        captionColor: null,
        question: null,
        answer: null,
        filterQuestion: null,
        filterAnswer: null
      }
      this.content.stats.push(payload)
      Vue.nextTick(()=>{
        this.$refs.statItems[this.content.stats.length-1].onEdit()
      })
    },
    refreshStat (i, event) {
      this.content.stats.splice(i, 1, event)
    },
    addStat (event) {
      event.key = this.generateKey()
      this.config.stats.push(event)
    },
    deleteStat (event) {
      let conf = confirm("Deletion is permanent. Are you sure?")
      if(conf){
        this.config.stats.splice(event, 1)
      } else {
        return
      }
    }
  },
  computed: {
    theme () {
      let themeOptions = {
      }
      return {
        ...themeOptions,
        ...this.config.theme
      }
    },
    titleColor () {
      return this.config.theme.titleColor || this.globalTheme.brandTitleColor || null
    },
    textColor () {
      return this.config.theme.textColor || this.globalTheme.brandTextColor || null
    },
    titleFontSize () {
      let size = this.config.theme.titleFontSize || this.globalTheme.titleFontSize || 100
      return size
    },
    textFontSize () {
      let size = this.config.theme.textFontSize || this.globalTheme.textFontSize || 100
      return size
    },
    computedBackgroundColor () {
      return this.config.theme.backgroundColor || this.globalTheme.brandColor
    }
  },
  created () {
    this.content = this.config
    this.save = _.debounce(function(){
      if (!this.editable) {
        return
      }
      this.$store.dispatch('saveItem', this.config)
    }, 500)
  },
  watch: {
    content: {
      handler: function(content){
        if(!this.ready){
          this.ready = true
          return
        }
        this.$store.commit('setDirty', true)
        this.save()
      },
      deep: true
    }
  }
}
</script>
<style lang='scss' scoped>
  @import '../../../../scss/components/variables';
  @import '../../../../scss/components/form';
  @import '../scss/report_items';
  .report-item--statgroup {
    background-size: cover;
    min-height: 250px;
    padding: 0 0;
    //height: 20vh;

    .actions {
      display: flex;
      min-height: 100px;
      align-items: center;
      justify-content: center;
      h2.editHeading {
        text-align: center;
        color: #ccc;
        width: 50%;
        cursor: pointer;
        font-size: 200%;
        ion-icon {
          vertical-align: -5px;
        }
      }
    }


    .stats {
      box-shadow: 0px 0px 7px 3px rgba(0,0,0,0.05);
      background-color: rgba(255,255,255,0.4);
      padding: 0.75rem 2rem 0.25rem 2rem;
      border-radius: 10px;
      margin-top: 2rem;
      .stat + .stat {
        border-top: 2px solid #ccc;
      }
      /deep/ .stat {
        .caption p {
          @media (min-width: 768px){
            font-size: 120%;
          }
          @media (min-width: 920px){
            font-size: 140%;
          }
          @media (min-width: 1200px){
            font-size: 150%;
          }
        }
      }
    }
    @media(min-width: 768px) {
      min-height: 300px;
      padding: 0.75rem 0 0.25rem 0;
      .stats {
        margin-top: 1.5rem;
      }
    }
    @media(min-width: 920px) {
      min-height: 400px;
      // height: 45vh;
    }
    .text {
      display: flex;
      height:100%;
      justify-content: center;
      flex-direction: column;
      width: 85%;
      margin:auto;
      h1 {
        //margin-bottom: 0.1rem;
      }
      h2 {
        margin-top: 0;
      }
      @media (min-width: 768px){
        width: 80%;
      }
    }
  }
</style>